import { render, staticRenderFns } from "./SpoiledHints.vue?vue&type=template&id=63e70b26&scoped=true&"
import script from "./SpoiledHints.vue?vue&type=script&lang=js&"
export * from "./SpoiledHints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e70b26",
  null
  
)

export default component.exports